import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { checkNetworkIsEqualToWalletNetwork } from '@orionprotocol/utils';

 
import { getAppChainId, getWalletChainId } from '../../redux/selectors';

export const useReadOnly = (): boolean => {
  const appChainId = useSelector(getAppChainId);
  const walletChainId = useSelector(getWalletChainId);
  const networksDontMatch = useMemo(
    () => !checkNetworkIsEqualToWalletNetwork(appChainId, walletChainId),
    [appChainId, walletChainId],
  );

  return networksDontMatch;
};
